import { ItemMasterData, ItemMasterDataFilters, ItemMasterDataPaginationParams, ApiResponse, ItemMasterDataPaginatedResponse } from '../types/item-master-data';

// 商品主数据模拟数据
export const itemMasterDataList: ItemMasterData[] = [
  {
    ownerCode: 'makro',
    code: 'ITEM001',
    name: 'Coca-Cola 330ml',
    englishName: 'Coca-Cola 330ml',
    abbr: 'Coke',
    stockUnit: 'PCS',
    length: 6.5,
    width: 6.5,
    height: 11.5,
    length4PDQ: 26.0,
    width4PDQ: 13.0,
    height4PDQ: 11.5,
    amount4XInPDQ: 4,
    amount4YInPDQ: 2,
    amount4ZInPDQ: 1,
    volume: 487.375,
    grossWeight: 0.35,
    netWeight: 0.33,
    itemType: 'Facing+Location Only',
    status: 'Active',
    strategicFlag: true,
    displayType: 'uom',
    firstReceivedTime: 1705308600000,  // 添加第一次到货时间
    selfBrandFlag: false,
    hasEdit: true,
    brandCode: 'COCA001',
    brandName: 'Coca-Cola',
    category1Id: 'DIV001',
    category1Name: 'Beverage Division',
    category2Id: 'DEP001',
    category2Name: 'Carbonated Drinks Department',
    category3Id: 'SEC001',
    category3Name: 'Cola Category',
    category4Id: 'CLS001',
    category4Name: 'Classic Cola',
    category5Id: 'SUB001',
    category5Name: '330ml Pack',
    group: 'Beverage Group',
    packaging: 'Bottle',
    packSize: '330ml',
    size: '330ml',
    weightOnLabel: '330ml',
    capacity: '330ml',
    price: 3.50,
    flavor: 'Sweet',
    color: 'Red',
    pattern: 'Classic Logo',
    smell: 'Cola Flavor',
    variants: 'None',
    creatorAccount: 'john.smith',
    creatorName: 'John Smith',
    gmtCreate: 1705308600000, // 2024-01-15 10:30:00
    modifierAccount: 'jane.doe',
    modifierName: 'Jane Doe',
    gmtModified: 1705740330000, // 2024-01-20 14:25:30
    imageList: [
      'https://example.com/images/coca-cola-1.jpg',
      'https://example.com/images/coca-cola-2.jpg'
    ],
    remark: 'Classic Coca-Cola, 330ml bottle',
    // 陈列参数配置（平铺）
    allowShelfDisplay: true,
    allowHole: false,
    oritation: 'front',
    allowStack: false,
    allowNest: false,
    nestHeight: undefined,
    displayConfigGmtCreate: 1705308600000,
    displayConfigGmtModified: 1705740330000,
    displayConfigCreatorAccount: 'john.smith',
    displayConfigModifierAccount: 'jane.doe'
  },
  {
    ownerCode: 'makro',
    code: 'ITEM002',
    name: 'Pepsi Cola 330ml',
    englishName: 'Pepsi Cola 330ml',
    abbr: 'Pepsi',
    stockUnit: 'PCS',
    length: 6.5,
    width: 6.5,
    height: 11.5,
    volume: 487.375,
    grossWeight: 0.35,
    netWeight: 0.33,
    itemType: 'Facing+Location Only',
    status: 'Active',
    strategicFlag: true,
    displayType: 'uom',
    firstReceivedTime: 1705308600000,  // 添加第一次到货时间
    selfBrandFlag: false,
    hasEdit: false,
    brandCode: 'PEPSI001',
    brandName: 'Pepsi',
    category1Id: 'DIV001',
    category1Name: 'Beverage Division',
    category2Id: 'DEP001',
    category2Name: 'Carbonated Drinks Department',
    category3Id: 'SEC001',
    category3Name: 'Cola Category',
    category4Id: 'CLS002',
    category4Name: 'Pepsi Cola',
    category5Id: 'SUB002',
    category5Name: '330ml Pack',
    group: 'Beverage Group',
    packaging: 'Bottle',
    packSize: '330ml',
    price: 3.00,
    flavor: 'Sweet',
    color: 'Blue',
    creatorAccount: 'john.smith',
    creatorName: 'John Smith',
    gmtCreate: 1705308600000,
    modifierAccount: 'john.smith',
    modifierName: 'John Smith',
    gmtModified: 1705308600000,
    imageList: ['https://example.com/images/pepsi-1.jpg'],
    remark: 'Pepsi Cola, 330ml bottle',
    // 陈列参数配置（平铺）
    allowShelfDisplay: true,
    allowHole: false,
    oritation: 'front',
    allowStack: false,
    allowNest: false,
    nestHeight: undefined,
    displayConfigGmtCreate: 1705308600000,
    displayConfigGmtModified: 1705308600000,
    displayConfigCreatorAccount: 'john.smith',
    displayConfigModifierAccount: 'john.smith'
  },
  {
    ownerCode: 'makro',
    code: 'ITEM003',
    name: 'Master Kong Braised Beef Noodles',
    englishName: 'Master Kong Braised Beef Noodles',
    abbr: 'MK Noodles',
    stockUnit: 'PCS',
    length: 11.5,
    width: 11.5,
    height: 9.0,
    volume: 1173.75,
    grossWeight: 0.12,
    netWeight: 0.10,
    itemType: 'Location Only',
    status: 'Active',
    strategicFlag: false,
    displayType: 'uom',
    firstReceivedTime: 1705395000000,  // 添加第一次到货时间
    selfBrandFlag: false,
    hasEdit: true,
    brandCode: 'KONG001',
    brandName: 'Master Kong',
    category1Id: 'DIV002',
    category1Name: 'Food Division',
    category2Id: 'DEP003',
    category2Name: 'Instant Food Department',
    category3Id: 'SEC003',
    category3Name: 'Instant Noodles Category',
    category4Id: 'CLS003',
    category4Name: 'Braised Beef Flavor',
    category5Id: 'SUB003',
    category5Name: 'Bag Pack',
    group: 'Food Group',
    packaging: 'Bag',
    packSize: '100g',
    price: 4.50,
    flavor: 'Braised Beef',
    color: 'Red Package',
    creatorAccount: 'mike.wang',
    creatorName: 'Mike Wang',
    gmtCreate: 1705395000000,
    modifierAccount: 'mike.wang',
    modifierName: 'Mike Wang',
    gmtModified: 1705395000000,
    imageList: ['https://example.com/images/kangshifu-1.jpg'],
    remark: 'Master Kong Braised Beef Instant Noodles',
    // 陈列参数配置（平铺）
    allowShelfDisplay: true,
    allowHole: false,
    oritation: 'front',
    allowStack: true,
    allowNest: false,
    nestHeight: undefined,
    displayConfigGmtCreate: 1705395000000,
    displayConfigGmtModified: 1705395000000,
    displayConfigCreatorAccount: 'mike.wang',
    displayConfigModifierAccount: 'mike.wang'
  },
  {
    ownerCode: 'makro',
    code: 'ITEM004',
    name: 'Nongfu Spring Natural Water 550ml',
    englishName: 'Nongfu Spring Natural Water 550ml',
    abbr: 'Nongfu Water',
    stockUnit: 'PCS',
    length: 6.0,
    width: 6.0,
    height: 20.0,
    volume: 720,
    grossWeight: 0.57,
    netWeight: 0.55,
    itemType: 'Facing+Location Only',
    status: 'Active',
    strategicFlag: true,
    displayType: 'uom',
    firstReceivedTime: 1705481400000,  // 添加第一次到货时间
    selfBrandFlag: false,
    hasEdit: false,
    brandCode: 'NONGFU001',
    brandName: 'Nongfu Spring',
    category1Id: 'DIV001',
    category1Name: 'Beverage Division',
    category2Id: 'DEP002',
    category2Name: 'Packaged Water Department',
    category3Id: 'SEC002',
    category3Name: 'Natural Water Category',
    category4Id: 'CLS004',
    category4Name: 'Natural Spring Water',
    category5Id: 'SUB004',
    category5Name: '550ml Pack',
    group: 'Beverage Group',
    packaging: 'Bottle',
    packSize: '550ml',
    price: 2.50,
    color: 'Transparent',
    creatorAccount: 'david.zhao',
    creatorName: 'David Zhao',
    gmtCreate: 1705481400000,
    modifierAccount: 'david.zhao',
    modifierName: 'David Zhao',
    gmtModified: 1705481400000,
    imageList: ['https://example.com/images/nongfu-1.jpg'],
    remark: 'Nongfu Spring Natural Water, 550ml bottle',
    // 陈列参数配置（平铺）
    allowShelfDisplay: true,
    allowHole: true,
    oritation: 'side',
    allowStack: false,
    allowNest: false,
    nestHeight: undefined,
    displayConfigGmtCreate: 1705481400000,
    displayConfigGmtModified: 1705481400000,
    displayConfigCreatorAccount: 'david.zhao',
    displayConfigModifierAccount: 'david.zhao'
  },
  {
    ownerCode: 'makro',
    code: 'ITEM005',
    name: 'Oreo Original Cookies',
    englishName: 'Oreo Original Cookies',
    abbr: 'Oreo',
    stockUnit: 'PCS',
    length: 15.0,
    width: 10.0,
    height: 3.0,
    volume: 450,
    grossWeight: 0.32,
    netWeight: 0.30,
    itemType: 'Facing+Location Only',
    status: 'Active',
    strategicFlag: false,
    displayType: 'uom',
    firstReceivedTime: 1705567800000,  // 添加第一次到货时间
    selfBrandFlag: false,
    hasEdit: true,
    brandCode: 'OREO001',
    brandName: 'Oreo',
    category1Id: 'DIV002',
    category1Name: 'Food Division',
    category2Id: 'DEP004',
    category2Name: 'Bakery Products Department',
    category3Id: 'SEC004',
    category3Name: 'Cookies Category',
    category4Id: 'CLS005',
    category4Name: 'Sandwich Cookies',
    category5Id: 'SUB005',
    category5Name: 'Box Pack',
    group: 'Food Group',
    packaging: 'Box',
    packSize: '300g',
    price: 12.80,
    flavor: 'Vanilla Cream',
    color: 'Black & White',
    creatorAccount: 'sarah.sun',
    creatorName: 'Sarah Sun',
    gmtCreate: 1705567800000,
    modifierAccount: 'sarah.sun',
    modifierName: 'Sarah Sun',
    gmtModified: 1705567800000,
    imageList: ['https://example.com/images/oreo-1.jpg'],
    remark: 'Oreo Original Sandwich Cookies',
    // 陈列参数配置（平铺）
    allowShelfDisplay: true,
    allowHole: false,
    oritation: 'front',
    allowStack: true,
    allowNest: true,
    nestHeight: 15.0,
    displayConfigGmtCreate: 1705567800000,
    displayConfigGmtModified: 1705567800000,
    displayConfigCreatorAccount: 'sarah.sun',
    displayConfigModifierAccount: 'sarah.sun'
  },
  {
    ownerCode: 'makro',
    code: 'ITEM006',
    name: 'Head & Shoulders Anti-Dandruff Shampoo',
    englishName: 'Head & Shoulders Anti-Dandruff Shampoo',
    abbr: 'H&S Shampoo',
    stockUnit: 'PCS',
    length: 8.0,
    width: 5.0,
    height: 20.0,
    volume: 800,
    grossWeight: 0.42,
    netWeight: 0.40,
    itemType: 'Storage Only',
    status: 'Active',
    strategicFlag: false,
    displayType: 'uom',
    firstReceivedTime: 1705654200000,  // 添加第一次到货时间
    selfBrandFlag: false,
    hasEdit: false,
    brandCode: 'HEAD001',
    brandName: 'Head & Shoulders',
    category1Id: 'DIV003',
    category1Name: 'Personal Care Division',
    category2Id: 'DEP005',
    category2Name: 'Personal Care Department',
    category3Id: 'SEC005',
    category3Name: 'Hair Care Category',
    category4Id: 'CLS006',
    category4Name: 'Anti-Dandruff Shampoo',
    category5Id: 'SUB006',
    category5Name: '400ml Pack',
    group: 'Personal Care Group',
    packaging: 'Bottle',
    packSize: '400ml',
    price: 28.90,
    color: 'Blue',
    creatorAccount: 'emma.zhou',
    creatorName: 'Emma Zhou',
    gmtCreate: 1705654200000,
    modifierAccount: 'emma.zhou',
    modifierName: 'Emma Zhou',
    gmtModified: 1705654200000,
    imageList: ['https://example.com/images/head-shoulders-1.jpg'],
    remark: 'Head & Shoulders Anti-Dandruff Shampoo, 400ml bottle',
    // 陈列参数配置（平铺）
    allowShelfDisplay: true,
    allowHole: false,
    oritation: 'front',
    allowStack: false,
    allowNest: false,
    nestHeight: undefined,
    displayConfigGmtCreate: 1705654200000,
    displayConfigGmtModified: 1705654200000,
    displayConfigCreatorAccount: 'emma.zhou',
    displayConfigModifierAccount: 'emma.zhou'
  },
  {
    ownerCode: 'makro',
    code: 'ITEM007',
    name: 'Pringles Original Potato Chips',
    englishName: 'Pringles Original Potato Chips',
    abbr: 'Pringles',
    stockUnit: 'PCS',
    length: 7.5,
    width: 7.5,
    height: 23.0,
    volume: 1293.75,
    grossWeight: 0.18,
    netWeight: 0.165,
    itemType: 'Location Only',
    status: 'Active',
    strategicFlag: true,
    displayType: 'PDQ',
    firstReceivedTime: 1705740600000,  // 添加第一次到货时间
    selfBrandFlag: false,
    hasEdit: true,
    brandCode: 'PRING001',
    brandName: 'Pringles',
    category1Id: 'DIV002',
    category1Name: 'Food Division',
    category2Id: 'DEP006',
    category2Name: 'Snacks Department',
    category3Id: 'SEC006',
    category3Name: 'Potato Chips Category',
    category4Id: 'CLS007',
    category4Name: 'Original Flavor',
    category5Id: 'SUB007',
    category5Name: 'Can Pack',
    group: 'Snacks Group',
    packaging: 'Can',
    packSize: '165g',
    price: 15.50,
    flavor: 'Original',
    color: 'Red',
    creatorAccount: 'alex.li',
    creatorName: 'Alex Li',
    gmtCreate: 1705740600000,
    modifierAccount: 'alex.li',
    modifierName: 'Alex Li',
    gmtModified: 1705740600000,
    imageList: ['https://example.com/images/pringles-1.jpg'],
    remark: 'Pringles Original Potato Chips, 165g can',
    // 陈列参数配置（平铺）
    allowShelfDisplay: true,
    allowHole: false,
    oritation: 'front',
    allowStack: true,
    allowNest: false,
    nestHeight: undefined,
    displayConfigGmtCreate: 1705740600000,
    displayConfigGmtModified: 1705740600000,
    displayConfigCreatorAccount: 'alex.li',
    displayConfigModifierAccount: 'alex.li'
  },
  {
    ownerCode: 'makro',
    code: 'ITEM008',
    name: 'Kleenex Facial Tissue Box',
    englishName: 'Kleenex Facial Tissue Box',
    abbr: 'Kleenex',
    stockUnit: 'PCS',
    length: 24.0,
    width: 12.0,
    height: 8.0,
    volume: 2304,
    grossWeight: 0.25,
    netWeight: 0.22,
    itemType: 'Storage Only',
    status: 'Active',
    strategicFlag: false,
    displayType: 'uom',
    firstReceivedTime: 1705827000000,  // 添加第一次到货时间
    selfBrandFlag: false,
    hasEdit: false,
    brandCode: 'KLEIN001',
    brandName: 'Kleenex',
    category1Id: 'DIV004',
    category1Name: 'Household Division',
    category2Id: 'DEP007',
    category2Name: 'Paper Products Department',
    category3Id: 'SEC007',
    category3Name: 'Facial Tissue Category',
    category4Id: 'CLS008',
    category4Name: 'Box Tissue',
    category5Id: 'SUB008',
    category5Name: '200 Sheets',
    group: 'Household Group',
    packaging: 'Box',
    packSize: '200 sheets',
    price: 8.90,
    color: 'White',
    pattern: 'Plain',
    creatorAccount: 'lisa.chen',
    creatorName: 'Lisa Chen',
    gmtCreate: 1705827000000,
    modifierAccount: 'lisa.chen',
    modifierName: 'Lisa Chen',
    gmtModified: 1705827000000,
    imageList: ['https://example.com/images/kleenex-1.jpg'],
    remark: 'Kleenex Facial Tissue Box, 200 sheets',
    // 陈列参数配置（平铺）
    allowShelfDisplay: true,
    allowHole: false,
    oritation: 'front',
    allowStack: true,
    allowNest: false,
    nestHeight: undefined,
    displayConfigGmtCreate: 1705827000000,
    displayConfigGmtModified: 1705827000000,
    displayConfigCreatorAccount: 'lisa.chen',
    displayConfigModifierAccount: 'lisa.chen'
  }
];

/**
 * 获取商品主数据分页列表（模拟）
 */
export async function getItemMasterDataMockResponse(
  filters: ItemMasterDataFilters,
  pagination: ItemMasterDataPaginationParams
): Promise<ApiResponse<ItemMasterDataPaginatedResponse>> {
  await new Promise(resolve => setTimeout(resolve, 500)); // 模拟网络延迟

  let filteredItems = [...itemMasterDataList];

  // 应用筛选条件
  if (filters.ownerCode) {
    filteredItems = filteredItems.filter(item => 
      item.ownerCode.toLowerCase().includes(filters.ownerCode!.toLowerCase())
    );
  }

  if (filters.itemCode) {
    filteredItems = filteredItems.filter(item => 
      item.code.toLowerCase().includes(filters.itemCode!.toLowerCase())
    );
  }

  if (filters.itemName) {
    filteredItems = filteredItems.filter(item => 
      item.name.toLowerCase().includes(filters.itemName!.toLowerCase())
    );
  }

  if (filters.englishName) {
    filteredItems = filteredItems.filter(item => 
      item.englishName?.toLowerCase().includes(filters.englishName!.toLowerCase())
    );
  }

  if (filters.abbr) {
    filteredItems = filteredItems.filter(item => 
      item.abbr?.toLowerCase().includes(filters.abbr!.toLowerCase())
    );
  }

  if (filters.stockUnit) {
    filteredItems = filteredItems.filter(item => item.stockUnit === filters.stockUnit);
  }

  if (filters.itemType) {
    filteredItems = filteredItems.filter(item => item.itemType === filters.itemType);
  }

  if (filters.status) {
    filteredItems = filteredItems.filter(item => item.status === filters.status);
  }

  if (filters.brandCode) {
    filteredItems = filteredItems.filter(item => 
      item.brandCode?.toLowerCase().includes(filters.brandCode!.toLowerCase())
    );
  }

  if (filters.brandName) {
    filteredItems = filteredItems.filter(item => 
      item.brandName?.toLowerCase().includes(filters.brandName!.toLowerCase())
    );
  }

  if (filters.strategicFlag !== undefined) {
    filteredItems = filteredItems.filter(item => item.strategicFlag === filters.strategicFlag);
  }

  if (filters.displayType) {
    filteredItems = filteredItems.filter(item => item.displayType === filters.displayType);
  }

  if (filters.firstReceivedTime !== undefined) {
    filteredItems = filteredItems.filter(item => item.firstReceivedTime === filters.firstReceivedTime);
  }

  if (filters.selfBrandFlag !== undefined) {
    filteredItems = filteredItems.filter(item => item.selfBrandFlag === filters.selfBrandFlag);
  }

  // 全局搜索
  if (filters.search) {
    const searchLower = filters.search.toLowerCase();
    filteredItems = filteredItems.filter(item => 
      item.code.toLowerCase().includes(searchLower) ||
      item.name.toLowerCase().includes(searchLower) ||
      item.englishName?.toLowerCase().includes(searchLower) ||
      item.abbr?.toLowerCase().includes(searchLower) ||
      item.brandName?.toLowerCase().includes(searchLower)
    );
  }

  // 排序
  if (pagination.sortBy && pagination.sortOrder) {
    filteredItems.sort((a, b) => {
      const aValue = a[pagination.sortBy as keyof ItemMasterData];
      const bValue = b[pagination.sortBy as keyof ItemMasterData];
      
      if (aValue < bValue) {
        return pagination.sortOrder === 'ascend' ? -1 : 1;
      }
      if (aValue > bValue) {
        return pagination.sortOrder === 'ascend' ? 1 : -1;
      }
      return 0;
    });
  }

  // 分页
  const startIndex = (pagination.currentPage - 1) * pagination.pageSize;
  const endIndex = startIndex + pagination.pageSize;
  const pageData = filteredItems.slice(startIndex, endIndex);

  return {
    traceId: 'mock-trace-' + Date.now(),
    success: true,
    errorMessage: null,
    data: {
      tableData: pageData,
      paging: {
        currentPage: pagination.currentPage,
        totalCount: filteredItems.length,
        pageSize: pagination.pageSize,
        totalPages: Math.ceil(filteredItems.length / pagination.pageSize)
      }
    }
  };
}

/**
 * 根据商品编码获取详情（模拟）
 */
export async function getItemDetailMockResponse(code: string): Promise<ApiResponse<ItemMasterData>> {
  await new Promise(resolve => setTimeout(resolve, 300)); // 模拟网络延迟

  const item = itemMasterDataList.find(item => item.code === code);

  if (item) {
    return {
      traceId: 'mock-trace-detail-' + Date.now(),
      success: true,
      errorMessage: null,
      data: item
    };
  } else {
    return {
      traceId: 'mock-trace-detail-' + Date.now(),
      success: false,
      errorMessage: '商品不存在',
      data: null
    };
  }
}